export default {
  trackSwitchedStyle: { backgroundColor: 'rgba(34, 193, 90, 0.5)' },
  thumbSwitchedStyle: { backgroundColor: '#22c15a' },
};



// WEBPACK FOOTER //
// ../ui-components/components/Switch/style.js